"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _exercise_type = _interopRequireDefault(require("./exercise_type"));
var _exercise_entry = _interopRequireDefault(require("./exercise_entry"));
var _worksheet_basic = _interopRequireDefault(require("./worksheet_basic"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _exercise_tag = _interopRequireDefault(require("./exercise_tag"));
var _tag = _interopRequireDefault(require("./tag"));
var _exercise_state = _interopRequireDefault(require("./exercise_state"));
var _forum_thread = _interopRequireDefault(require("./forum_thread"));
var _serializer_helpers = require("./utils/serializer_helpers");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Exercise = (_dec = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec2 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec3 = (0, _serializr.serializable)((0, _serializr.object)(_worksheet_basic["default"])), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_exercise_type["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_exercise_entry["default"]))), _dec6 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_exercise_tag["default"]))), _dec7 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_tag["default"]))), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_forum_thread["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function Exercise(obj) {
    var _this;
    _classCallCheck(this, Exercise);
    _this = _callSuper(this, Exercise, [obj]);
    _initializerDefineProperty(_this, "userExerciseId", _descriptor, _this);
    _initializerDefineProperty(_this, "id", _descriptor2, _this);
    _initializerDefineProperty(_this, "name", _descriptor3, _this);
    _initializerDefineProperty(_this, "slug", _descriptor4, _this);
    _initializerDefineProperty(_this, "position", _descriptor5, _this);
    _initializerDefineProperty(_this, "pdfDescription", _descriptor6, _this);
    _initializerDefineProperty(_this, "exerciseEntriesCount", _descriptor7, _this);
    _initializerDefineProperty(_this, "usersStartedCount", _descriptor8, _this);
    _initializerDefineProperty(_this, "usersFinishedCount", _descriptor9, _this);
    _initializerDefineProperty(_this, "averageAttemptsCount", _descriptor0, _this);
    _initializerDefineProperty(_this, "usersPercentageFinished", _descriptor1, _this);
    _initializerDefineProperty(_this, "correctAnswersCount", _descriptor10, _this);
    _initializerDefineProperty(_this, "worksheetId", _descriptor11, _this);
    _initializerDefineProperty(_this, "defaultDescription", _descriptor12, _this);
    _initializerDefineProperty(_this, "expandedDescription", _descriptor13, _this);
    _initializerDefineProperty(_this, "cumulativeRatings", _descriptor14, _this);
    _initializerDefineProperty(_this, "ratingsCount", _descriptor15, _this);
    _initializerDefineProperty(_this, "ratingsAverage", _descriptor16, _this);
    _initializerDefineProperty(_this, "ratingsWithCommentsCount", _descriptor17, _this);
    _initializerDefineProperty(_this, "descriptionVideo", _descriptor18, _this);
    _initializerDefineProperty(_this, "capitalizeEntries", _descriptor19, _this);
    _initializerDefineProperty(_this, "showTipIcon", _descriptor20, _this);
    _initializerDefineProperty(_this, "showOptionsInAlphabeticalOrder", _descriptor21, _this);
    _initializerDefineProperty(_this, "optionsDisplayed", _descriptor22, _this);
    _initializerDefineProperty(_this, "completed", _descriptor23, _this);
    _initializerDefineProperty(_this, "validSetup", _descriptor24, _this);
    _initializerDefineProperty(_this, "aiStatus", _descriptor25, _this);
    _initializerDefineProperty(_this, "aiChatId", _descriptor26, _this);
    _initializerDefineProperty(_this, "humanFeedback", _descriptor27, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor28, _this);
    _initializerDefineProperty(_this, "userExerciseUpdatedAt", _descriptor29, _this);
    _initializerDefineProperty(_this, "worksheet", _descriptor30, _this);
    _initializerDefineProperty(_this, "exerciseType", _descriptor31, _this);
    _initializerDefineProperty(_this, "exerciseEntries", _descriptor32, _this);
    _initializerDefineProperty(_this, "exerciseTags", _descriptor33, _this);
    _initializerDefineProperty(_this, "tags", _descriptor34, _this);
    _initializerDefineProperty(_this, "forumThread", _descriptor35, _this);
    _this.state = new _exercise_state["default"](_this);
    return _this;
  }
  _inherits(Exercise, _RootModel);
  return _createClass(Exercise, [{
    key: "descriptionVideoIsValid",
    get: /** Same rule as Worksheet#youtubeUrlIsValid — admin expects https://www.youtube.com/watch?v=… */
    function get() {
      return (0, _utils.isPresent)(this.descriptionVideo) && String(this.descriptionVideo).startsWith('https://www.youtube.com/watch?v=');
    }
  }, {
    key: "formattedDescriptionVideo",
    get: function get() {
      if ((0, _utils.isPresent)(this.descriptionVideo) && this.descriptionVideo.match('watch')) {
        var regexp = /watch\?v=(...........)/g;
        var match = regexp.exec(this.descriptionVideo);
        if (match) {
          return "https://www.youtube.com/embed/".concat(match[1]);
        }
      } else {
        return this.descriptionVideo;
      }
      return null;
    }
  }, {
    key: "shuffledExerciseEntries",
    get: function get() {
      return (0, _lodash.shuffle)(this.exerciseEntries);
    }
  }, {
    key: "orderedTags",
    get: function get() {
      return (0, _lodash.orderBy)(this.tags, ['overallPosition']);
    }
  }, {
    key: "levelTags",
    get: function get() {
      return this.orderedTags.filter(function (item) {
        return item.level;
      });
    }
  }, {
    key: "levelTagsFormatted",
    get: function get() {
      if (this.levelTags && this.levelTags.length > 1) {
        return "".concat(this.levelTags[0].name, "+");
      }
      return this.levelTags.map(function (item) {
        return item.name;
      }).join(', ');
    }
  }, {
    key: "exerciseTypeName",
    get: function get() {
      return this.hasExerciseType ? this.exerciseType.name : null;
    }
  }, {
    key: "exerciseTypeId",
    get: function get() {
      return this.hasExerciseType ? this.exerciseType.id : null;
    }
  }, {
    key: "anyIncorrect",
    get: function get() {
      return this.incorrectWordAssociations || this.incorrectExerciseEntries;
    }
  }, {
    key: "incorrectWordAssociations",
    get: function get() {
      return (0, _utils.isPresent)(this.selectedWordAssociations.find(function (item) {
        return !item.state.correct;
      }));
    }
  }, {
    key: "incorrectExerciseEntries",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseEntries.find(function (item) {
        return !item.state.correct;
      }));
    }
  }, {
    key: "hasExerciseType",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseType);
    }
  }, {
    key: "hasExerciseEntries",
    get: function get() {
      return (0, _utils.isPresent)((0, _mobx.toJS)(this.exerciseEntries));
    }
  }, {
    key: "enriched",
    get: function get() {
      return (0, _utils.isPresent)(this.exerciseEntries);
    }
  }, {
    key: "expandedDescriptionFormatted",
    get: function get() {
      return (0, _utils.isPresent)(this.expandedDescription) ? this.expandedDescription : null;
    }
  }, {
    key: "defaultDescriptionFormatted",
    get: function get() {
      return (0, _utils.isPresent)(this.defaultDescription) ? this.defaultDescription.replace(/(?:\r\n|\r|\n)/g, '<br />') : null;
    }
  }, {
    key: "descriptionFormatted",
    get: function get() {
      return (0, _utils.isPresent)(this.description) ? this.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : null;
    }
  }, {
    key: "selectedWordAssociations",
    get: function get() {
      return (0, _lodash.compact)((0, _lodash.flatten)(this.exerciseEntries.map(function (item) {
        return item.sentence && item.sentence.selectedWordAssociations;
      })));
    }
  }, {
    key: "selectedUniqueWordAssociations",
    get: function get() {
      var unique = (0, _lodash.uniqBy)(this.selectedWordAssociations, 'targetText');
      if (this.showOptionsInAlphabeticalOrder) {
        return (0, _lodash.orderBy)(unique, function (wa) {
          return wa.targetText.toLowerCase();
        });
      }
      return unique;
    }
  }, {
    key: "wordAssociationsWithExtraWords",
    get: function get() {
      return (0, _lodash.compact)((0, _lodash.flatten)(this.exerciseEntries.map(function (item) {
        return item.wordAssociationsWithExtraWords;
      })));
    }
  }, {
    key: "shuffledWordAssociationsWithExtraWords",
    get: function get() {
      return (0, _lodash.shuffle)(this.wordAssociationsWithExtraWords);
    }
  }, {
    key: "selectedUniqueWords",
    get: function get() {
      var words = (0, _lodash.uniq)(this.selectedWordAssociations.map(function (item) {
        return item.targetText;
      }));
      if (this.showOptionsInAlphabeticalOrder) {
        return (0, _lodash.orderBy)(words, function (w) {
          return w.toLowerCase();
        });
      }
      return (0, _lodash.shuffle)(words);
    }
  }, {
    key: "shuffledSelectedWordAssociations",
    get: function get() {
      return (0, _lodash.shuffle)(this.selectedWordAssociations);
    }
  }, {
    key: "allSentenceExerciseEntriesHaveValues",
    get: function get() {
      var _this$exerciseEntries;
      return (0, _lodash.every)((_this$exerciseEntries = this.exerciseEntries) === null || _this$exerciseEntries === void 0 ? void 0 : _this$exerciseEntries.map(function (entry) {
        return entry.sentence.allWordAssociationsHaveValues;
      }));
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userExerciseId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "slug", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "position", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pdfDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "exerciseEntriesCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "usersStartedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "usersFinishedCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "averageAttemptsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "usersPercentageFinished", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "correctAnswersCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "defaultDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "expandedDescription", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "cumulativeRatings", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "ratingsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "ratingsAverage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "ratingsWithCommentsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "descriptionVideo", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "capitalizeEntries", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "showTipIcon", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "showOptionsInAlphabeticalOrder", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "optionsDisplayed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "completed", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "validSetup", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "aiStatus", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "aiChatId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "humanFeedback", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "userExerciseUpdatedAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "worksheet", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "exerciseType", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "exerciseEntries", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "exerciseTags", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "tags", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "forumThread", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "descriptionVideoIsValid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "descriptionVideoIsValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedDescriptionVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedDescriptionVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shuffledExerciseEntries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shuffledExerciseEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderedTags", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderedTags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelTags", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelTags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelTagsFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelTagsFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseTypeName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseTypeName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseTypeId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "anyIncorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "anyIncorrect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incorrectWordAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "incorrectWordAssociations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incorrectExerciseEntries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "incorrectExerciseEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasExerciseType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasExerciseType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasExerciseEntries", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasExerciseEntries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enriched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "enriched"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expandedDescriptionFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "expandedDescriptionFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultDescriptionFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultDescriptionFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "descriptionFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "descriptionFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordAssociations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedUniqueWordAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedUniqueWordAssociations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordAssociationsWithExtraWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordAssociationsWithExtraWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shuffledWordAssociationsWithExtraWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shuffledWordAssociationsWithExtraWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedUniqueWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedUniqueWords"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shuffledSelectedWordAssociations", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "shuffledSelectedWordAssociations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allSentenceExerciseEntriesHaveValues", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allSentenceExerciseEntriesHaveValues"), _class.prototype), _class);
var _default = exports["default"] = Exercise;